import createLeftAddonComponent from "../../../../helpers/common/CoreInputText/components/LeftAddon/fabric";
import { SEARCH_DISPLAY_NAME } from "../../utils/core";

export const Component = createLeftAddonComponent(SEARCH_DISPLAY_NAME);
